import store from '@/store'
import { Message, MessageBox } from 'element-ui'

export function responseOK (response) {
  let token = response && response.headers && response.headers['authorization']
  if (token) {
    // 实时更新服务器返回的新的token
    store.dispatch('SetToken', token)
  }
}

async function readBlobAsText (blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(reader.error)
    reader.readAsText(blob)
  })
}

export async function responseFailure (error) {
  console.log('err ' + error) // for debug
  let res
  if (error.response) {
    // 处理blob错误的时候返回json的问题
    const contentType = error.response.headers['content-type']
    if (error.response.config.responseType === 'blob' && contentType && contentType.includes('application/json')) {
      res = JSON.parse(await readBlobAsText(error.response.data))
    }
  }
  if (!res) {
    res = error.response && error.response.data && (error.response.data.code || error.response.data.error) ? error.response.data : null
  }
  if (!res) {
    res = error.message ? JSON.parse(error.message) : null
  }
  if (!res) {
    Message({
      message: '连接失败，请检查本地网络是否正常，稍后再试',
      type: 'error',
      duration: 5 * 1000
    })
  } else {
    if (res.code === -41000) {
      MessageBox.alert(res.error, '未登录', {
        confirmButtonText: '确定',
        type: 'error'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          location.reload()
        })
      })
    } else if (res.error && res.error.length > 0) {
      MessageBox.alert(res.error, '错误', {
        confirmButtonText: '确定',
        type: 'error'
      })
    }
  }
  return res
}

export function responseDownload (response) {
  const contentType = response.headers['content-type'] || 'application/octet-stream'
  let blob = response.data instanceof Blob ? response.data : new Blob([response.data], {
    type: contentType
  })
  // let blob = new Blob([response.data], {
  //   type: contentType
  // })
  let fileName = response.headers['file-name'] || response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '') || 'download'
  try {
    fileName = decodeURIComponent(escape(fileName))
  } catch (e) {
    console.log('Filename decode error, using original name')
  }
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName)
  } else {
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fileName
    link.click()
    // 释放内存
    window.URL.revokeObjectURL(link.href)
  }
}



// WEBPACK FOOTER //
// ./src/utils/rsp.js